// extracted by mini-css-extract-plugin
module.exports = {"faq_container":"style_faq_container__1Qgqd","expand":"style_expand__2FFxM","beat":"style_beat__3KQIY","puzzle":"style_puzzle__3Bvso"};